import React, { Component } from "react";
// import { Text } from '@sitecore-jss/sitecore-jss-react';
import "./style.scss";
import classNames from "classnames";
import AutoListContentItem from "../../react-components/Auto-List-Content-Item";
import IframeModal from "../../react-components/iframe-modal";
import PrimaryLink from "../../elements/primary-link";
import Heading from "../../elements/heading";
import api from "../../utils/api";
import { format } from "../../utils";
import GraphQLData from "../../lib/GraphQLData";
import gql from "graphql-tag";
// const storiesQuery = gqlLoader("./query.graphql");

const storiesQuery = gql`
  query storiesQuery($itemPath: String = "/sitecore/content/lynkco-global-portal/Home/Stories") {
    datasource: datasource(value: $itemPath) {
      name
      path
      children(requirePresentation: true) {
        name
        children(requirePresentation: true) {
          name
          url
          itemData: field(name: "itemData") {
            jss
            # ... on ReferenceField {
            #   targetItem {
            #     ... on HeroStory {
            #       author {
            #         value
            #       }
            #       authorImage {
            #         src
            #         alt
            #         width
            #         height
            #       }
            #       backgroundImage {
            #         src
            #         alt
            #         width
            #         height
            #       }
            #       barColor {
            #         path
            #         ... on ReferenceField {
            #           targetItem {
            #             url
            #             # key: field(name: "key") {
            #             #   value
            #             # }
            #             # phrase: field(name: "phrase") {
            #             #   value
            #             # }
            #           }
            #         }
            #       }
            #       date {
            #         value
            #       }
            #       headingBody {
            #         value
            #       }
            #       # headingType {
            #       #   targetItem {
            #       #     key: field(name: "key") {
            #       #       ...ItemField
            #       #     }
            #       #     phrase: field(name: "phrase") {
            #       #       ...ItemField
            #       #     }
            #       #   }
            #       # }
            #       listTitle {
            #         value
            #       }
            #       # subjects {
            #       #   targetItems {
            #       #     key: field(name: "key") {
            #       #       ...ItemField
            #       #     }
            #       #     phrase: field(name: "phrase") {
            #       #       ...ItemField
            #       #     }
            #       #   }
            #       # }
            #     }
            #   }
            # }
          }
        }
      }
    }
  }
  # fragment ItemField on ItemField {
  #   value
  # }
`;

class AutListContent extends Component {
  constructor(props, context) {
    super(props, context);
    const { fields = {} } = this.props,
      { size, nestedGrid } = fields;
    this.state = {
      loading: true,
      items: props.fields.items || [],
      currentPage: 1,
      pageSize: Number((size && size.value) || 10000),
      iframemodel: {
        show: false,
        isIframe: {},
        nestedGrid: nestedGrid && nestedGrid.value
      }
    };
  }

  componentDidMount() {
    const { pageSize, currentPage } = this.state;
    const { fields, lang } = this.props,
      { IsColab, colabType, colabOrderBy } = fields;
    const _this = this;
    // let arr = [],
    // sub = [];
    // arr = storyType.map(el => el.fields.phrase.value.toUpperCase());
    // sub = subjects.map(el => `${el.fields.phrase.value}`);
    if (IsColab.value) {
      api.colab
        .get({
          lang: lang,
          page: currentPage,
          size: pageSize,
          type: colabType.fields.phrase.value,
          orderBy: colabOrderBy.fields.phrase.value
        })
        .then(res => {
          let items = [];
          res.items.forEach((item, index) => {
            items.push({
              fields: {
                type: { value: item.type },
                link: {
                  value: {
                    href: item.link,
                    linktype: item.linktype
                  }
                },
                image: {
                  value: {
                    src: item.image && item.image.url,
                    alt: item.image && item.image.alt
                  }
                },
                profileImage: {
                  value: {
                    src: item.profileImage && item.profileImage.url,
                    alt: item.profileImage && item.profileImage.alt
                  }
                },
                author: { value: item.author },
                subjects:
                  item.subjects &&
                  item.subjects.map(its => {
                    return { fields: { phrase: { value: its } } };
                  }),
                timestamp: {
                  value: format(item.timestamp, "yyyy-MM-ddTHH-mm-ss")
                },
                headingType: {
                  fields: {
                    phrase: { value: item.headingType }
                  }
                },
                headingBody: { value: item.headingBody }
              }
            });
          });
          _this.setState({
            items: items
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
  sortTime(list) {
    list.sort(function(prev, next) {
      let prev1 = null,
        next1 = null;
      prev1 = prev.fields.timestamp.value.replace(/[A-z]/g, " ");
      prev1 = prev1.replace(/-/g, "/");
      next1 = next.fields.timestamp.value.replace(/[A-z]/g, " ");
      next1 = next1.replace(/-/g, "/");
      return prev1 < next1 ? 1 : -1;
    });
  }
  selectQlData() {
    const { pageSize } = this.state;
    const { fields, lang, storiesQuery } = this.props,
      { datasource } = storiesQuery,
      { storyType, subjects } = fields;
    let arr = [],
      QLdata = [],
      sub = [];
    arr = storyType.map(el => el.fields.phrase.value.toUpperCase());
    sub = subjects.map(el => `${el.fields.phrase.value}`);
    let stateItem = [];
    QLdata =
      datasource.children &&
      datasource.children.filter(el => {
        return arr.find(item => {
          return item === (el.name && el.name.toUpperCase());
        });
      });
    QLdata =
      QLdata &&
      QLdata.filter(el => {
        let newArr = [];
        el.children.forEach(item => {
          let arrr =
            item.itemData.jss.fields.subjects &&
            item.itemData.jss.fields.subjects.filter(subject => {
              return sub.filter(subitem => {
                return subitem === subject.fields.phrase.value;
              });
            });
          if (arrr && arrr.length) {
            newArr.push(item);
          }
        });
        return newArr;
      });
    QLdata.forEach(item => {
      item.children.forEach(child => {
        if (JSON.stringify(child.itemData.jss.fields) === "{}") {
          return null;
        }
        let { listTitle, backgroundImage, authorImage, author, subjects, date, headingType } = child.itemData.jss.fields;
        let childUrl = child.url.replace("/en/", `/${lang.toLowerCase()}/`);
        let itemschild = {
          fields: {
            type: { value: item.name },
            link: {
              value: {
                href: childUrl,
                linktype: "internal"
              }
            },
            image: backgroundImage,
            profileImage: authorImage,
            author: author,
            subjects: subjects,
            timestamp: date,
            headingType: headingType,
            headingBody: listTitle
          }
        };
        if (stateItem.length < pageSize) {
          stateItem.push(itemschild);
        }
      });
    });
    this.sortTime(stateItem);
    return { stateItem, loading: false };
    // this.setState({
    //   items: stateItem,
    //   loading: false
    // });
  }

  toggleIframe(item) {
    const { iframemodel } = this.state;
    const { fields } = this.props;
    const { nestedGrid } = fields;
    let iframe = {
      id: "auto-list-content-model",
      isIframe: { href: "" },
      show: !iframemodel.show,
      nestedGrid: nestedGrid.value
    };
    if (!iframemodel.show) {
      iframe.isIframe.href = item.href;
    }
    this.setState({
      iframemodel: iframe
    });
  }

  autoListContent(fields) {
    const { iframemodel, items } = this.state;
    const { gridType, paddingAboveTop, paddingAboveBottom, alignment, backgroundColor, headingBody, headingType, primaryLink, showModal, showCategory, IsColab } = fields;
    let grid = gridType ? gridType.fields.phrase.value : "normal",
      top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
      bottom = paddingAboveBottom ? paddingAboveBottom.fields.phrase.value : "default",
      backgroundStyle = {},
      list = items;
    if (!IsColab.value) {
      let QlData = this.selectQlData();
      list = QlData ? QlData.stateItem : list;
    }
    if (backgroundColor) {
      backgroundStyle = {
        background: backgroundColor && backgroundColor.fields ? backgroundColor.fields.phrase.value : ""
      };
    }
    const autoListContentClasses = classNames("auto-list-content", "padding-top-" + top, "padding-bottom-" + bottom, { grid: grid === "normal" }, { "grid-story": grid === "story" });

    const titleClasses = classNames("title show-on-scroll", {
      center: alignment && alignment.fields && alignment.fields.phrase.value === "center"
    });

    const itemsContaninerClasses = classNames("items-container", "show-on-scroll", "grid", "full-width", {
      "many-items": list.length > 3,
      "few-items": list.length < 4
    });
    return (
      <div className={autoListContentClasses} style={backgroundStyle} datasourceid={this.props.rendering.dataSource}>
        {headingBody && <Heading className={titleClasses} type={headingType} html={headingBody} />}
        {primaryLink && <PrimaryLink {...primaryLink.fields} />}
        <div className={itemsContaninerClasses} ref="itemsContainer">
          {list &&
            list.map((item, index) => {
              return <AutoListContentItem {...item} key={index} showCategory={showCategory} toggleIframe={item => this.toggleIframe(item)} showModal={showModal} />;
            })}
        </div>
        {iframemodel.show && <IframeModal {...iframemodel} toggleIframe={item => this.toggleIframe(item)} />}
      </div>
    );
  }

  render() {
    if (!this.props.fields) return null;
    const { fields, storiesQuery } = this.props;
    const { gridType } = fields;
    // console.log(storiesQuery);
    if (storiesQuery.loading) {
      // this.setState({
      //   loading:true
      // })
      return null;
    }

    if (gridType && gridType.fields.phrase.value === "story") {
      return <div className={"grid"}>{this.autoListContent(fields)}</div>;
    } else {
      return this.autoListContent(fields);
    }
  }
}

//export default AutListContent;
export default GraphQLData(storiesQuery, { name: "storiesQuery" })(AutListContent);
